import { put } from "redux-saga/effects";
import { message } from "antd";

import { ApiCaller } from "../../config";
import { ApplicationAction } from "../actions";
import { DefaultNotification } from "../../components";

export default class ApplicationMiddleware {
  static *getApplications({ payload, cb }) {
    try {
      const { limit, offset, schoolId } = payload;
      const res = yield ApiCaller.Get(
        `/school/fetch-applications?schoolId=${schoolId}&limit=${
          limit ?? ""
        }&offset=${offset ?? ""}`
      );
      if (res.status === 200) {
        yield put(ApplicationAction.getApplicationsSuccess(res.data.data));
      } else {
        yield put(ApplicationAction.getApplicationsFailure());
        message.error(res?.data?.message);
      }
      if (cb) {
        cb(res.data);
      }
    } catch (err) {
      yield put(ApplicationAction.getApplicationsFailure());
    }
  }
  static *changeApplicationStatus({ payload, cb }) {
    try {
      const res = yield ApiCaller.Put(
        `/school/change-application-status`,
        payload
      );
      if (res.status === 200) {
        yield put(
          ApplicationAction.changeApplicationStatusSuccess(res.data.data)
        );
        DefaultNotification(res?.data?.message, "success", "top");
      } else {
        yield put(ApplicationAction.changeApplicationStatusFailure());
        message.error(res?.data?.message);
      }
      if (cb) {
        cb(res.data);
      }
    } catch (err) {
      yield put(ApplicationAction.changeApplicationStatusFailure());
    }
  }
  static *getApplicationDetails({ payload, cb }) {
    try {
      const res = yield ApiCaller.Get(
        `/school/fetch-application-details?uniId=${payload?.uniId}`
      );
      if (res.status === 200) {
        yield put(
          ApplicationAction.getApplicationDetailsSuccess(res.data.data)
        );
      } else {
        yield put(ApplicationAction.getApplicationDetailsFailure());
        message.error(res?.data?.message);
      }
      if (cb) {
        cb(res.data);
      }
    } catch (err) {
      yield put(ApplicationAction.getApplicationDetailsFailure());
    }
  }
  static *reqLOR({ payload, cb }) {
    try {
      const res = yield ApiCaller.Put(`/school/update-lor`, payload);
      if (res.status === 200) {
        yield put(ApplicationAction.reqLORSuccess(res.data.data));
        DefaultNotification(res?.data?.message, "success", "top");
      } else {
        yield put(ApplicationAction.reqLORFailure());
        message.error(res?.data?.message);
      }
      if (cb) {
        cb(res.data);
      }
    } catch (err) {
      yield put(ApplicationAction.reqLORFailure());
    }
  }
}
